import React from 'react';
import { motion } from 'framer-motion';

const Services = () => {
  const services = [
    {
      title: 'Dental Services',
      items: [
        {
          name: 'Smile Makeover',
          description: 'Complete smile transformation with advanced cosmetic procedures',
          image: 'https://images.unsplash.com/photo-1663182234283-28941e7612da?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8U21pbGUlMjBtYWtvdmVyJTIwZGVudGFsfGVufDB8fDB8fHww',
          details: [
            'Comprehensive smile analysis',
            'Custom treatment planning',
            'Multiple cosmetic procedures',
            'Digital smile design',
            'Long-lasting results'
          ],
          icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          ),
        },
        {
          name: 'Teeth Whitening',
          description: 'Professional teeth whitening for a brighter, more confident smile',
          image: 'https://img.freepik.com/premium-photo/woman-teeth-before-after-whitening-white-background-dental-clinic-patient-image-symbolizes_168410-1760.jpg?uid=R66916925&ga=GA1.1.8515140.1733411424&semt=ais_hybrid&w=740',
          details: [
            'In-office whitening',
            'Take-home kits',
            'LED acceleration',
            'Custom trays',
            'Long-lasting results'
          ],
          icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          ),
        },
        {
          name: 'Routine Dentistry',
          description: 'Regular dental care and maintenance for optimal oral health',
          image: 'https://plus.unsplash.com/premium_photo-1677174625106-247055639564?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8Um91dGluZSUyMERlbnRpc3RyeXxlbnwwfHwwfHx8MA%3D%3D',
          details: [
            'Regular check-ups',
            'Professional cleaning',
            'Oral examination',
            'X-ray analysis',
            'Preventive care'
          ],
          icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          ),
        },
        {
          name: 'Root Canal Treatment',
          description: 'Advanced endodontic treatment to save damaged teeth',
          image: 'https://plus.unsplash.com/premium_photo-1674575270991-653fb6bfc1bf?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8Um9vdCUyMENhbmFsJTIwVHJlYXRtZW50fGVufDB8fDB8fHww',
          details: [
            'Painless procedure',
            'Advanced technology',
            'Complete tooth restoration',
            'Long-term solution',
            'Natural look and feel'
          ],
          icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
          ),
        },
        {
          name: 'Invisible Braces (Invisalign)',
          description: 'Modern orthodontic treatment with clear aligners',
          image: 'https://images.unsplash.com/photo-1667133295315-820bb6481730?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8SW52aXNpYmxlJTIwQnJhY2VzfGVufDB8fDB8fHww',
          details: [
            'Clear, removable aligners',
            'Custom treatment plan',
            'Comfortable fit',
            'Regular progress checks',
            'Minimal lifestyle impact'
          ],
          icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          ),
        },
        {
          name: 'Veneers',
          description: 'Custom-made shells to enhance your smile',
          image: 'https://plus.unsplash.com/premium_photo-1702598533345-57ecc9b1992d?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8VmVuZWVyc3xlbnwwfHwwfHx8MA%3D%3D',
          details: [
            'Porcelain veneers',
            'Custom design',
            'Natural appearance',
            'Stain-resistant',
            'Long-lasting results'
          ],
          icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          ),
        },
        {
          name: 'Pediatric Dentistry',
          description: 'Specialized dental care for children',
          image: 'https://img.freepik.com/free-psd/close-up-kid-expression-portrait_23-2150193069.jpg?uid=R66916925&ga=GA1.1.8515140.1733411424&semt=ais_hybrid&w=740',
          details: [
            'Child-friendly environment',
            'Early dental care',
            'Preventive treatments',
            'Behavior management',
            'Parent education'
          ],
          icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
          ),
        },
        {
          name: 'Tooth Jewellery',
          description: 'Decorative dental accessories for a unique smile',
          image: 'https://img.freepik.com/foto-gratis/vista-frontal-hombre-posando-gemas-dentales_23-2151212416.jpg?semt=ais_hybrid&w=740',
          details: [
            'Dental gems',
            'Custom designs',
            'Safe application',
            'Removable options',
            'Trendy styles'
          ],
          icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          ),
        },
      ],
    },
    {
      title: 'Cosmetology Services',
      items: [
        {
          name: 'Laser Hair Reduction (LHR)',
          description: 'Permanent hair reduction using advanced laser technology',
          image: 'https://img.freepik.com/free-photo/woman-cosmetology-studio-laser-hair-removal_1157-34889.jpg?uid=R66916925&ga=GA1.1.8515140.1733411424&semt=ais_hybrid',
          details: [
            'Advanced laser technology',
            'Permanent results',
            'Minimal discomfort',
            'Suitable for all skin types',
            'Multiple sessions for best results'
          ],
          icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          ),
        },
        {
          name: 'Chemical Peels',
          description: 'Professional skin exfoliation for improved texture and tone',
          image: 'https://img.freepik.com/free-photo/beautician-with-brush-applies-white-moisturizing-mask-face-young-girl-client-spa-beauty-salon_343596-4246.jpg?uid=R66916925&ga=GA1.1.8515140.1733411424&semt=ais_hybrid',
          details: [
            'Customized solutions',
            'Multiple peel options',
            'Safe and controlled',
            'Immediate results',
            'Post-treatment care'
          ],
          icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
          ),
        },
        {
          name: 'Medi-Facials',
          description: 'Advanced facial treatments with medical-grade products',
          image: 'https://img.freepik.com/free-photo/rejuvenating-facial-treatment_158595-4601.jpg?uid=R66916925&ga=GA1.1.8515140.1733411424&semt=ais_hybrid',
          details: [
            'Medical-grade products',
            'Deep cleansing',
            'Skin rejuvenation',
            'Customized treatment',
            'Professional care'
          ],
          icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          ),
        },
        {
          name: 'Glow Tox Glutathione Drip',
          description: 'Intravenous treatment for skin brightening and detoxification',
          image: 'https://img.freepik.com/free-photo/patient-getting-chemotherapy-treatment_23-2149261100.jpg?uid=R66916925&ga=GA1.1.8515140.1733411424&semt=ais_hybrid&w=740',
          details: [
            'Skin brightening',
            'Body detoxification',
            'Immune system boost',
            'Safe administration',
            'Visible results'
          ],
          icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          ),
        },
        {
          name: 'Acne Scar Reduction',
          description: 'Advanced treatments to minimize and remove acne scars',
          image: 'https://img.freepik.com/free-photo/before-after-portrait-woman-retouched_23-2149121636.jpg?uid=R66916925&ga=GA1.1.8515140.1733411424&semt=ais_hybrid',
          details: [
            'Multiple treatment options',
            'Scar assessment',
            'Customized approach',
            'Progressive improvement',
            'Long-lasting results'
          ],
          icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          ),
        },
        {
          name: 'Pigmentation Correction',
          description: 'Treatment for uneven skin tone and dark spots',
          image: 'https://img.freepik.com/free-photo/preparing-utensils-microneedling-procedure_23-2149374103.jpg?uid=R66916925&ga=GA1.1.8515140.1733411424&semt=ais_hybrid',
          details: [
            'Advanced lightening agents',
            'Custom treatment plans',
            'Safe procedures',
            'Visible improvement',
            'Maintenance guidance'
          ],
          icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          ),
        },
        {
          name: 'Hair Growth Treatments',
          description: 'Comprehensive solutions for hair loss and thinning',
          image: 'https://img.freepik.com/free-photo/man-getting-hair-loss-treatment_23-2149152756.jpg?uid=R66916925&ga=GA1.1.8515140.1733411424&semt=ais_hybrid',
          details: [
            'Hair analysis',
            'Customized solutions',
            'Advanced treatments',
            'Regular monitoring',
            'Long-term results'
          ],
          icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
          ),
        },
        {
          name: 'PRP & GFC for Hair and Face',
          description: 'Advanced regenerative treatments for hair and skin',
          image: 'https://img.freepik.com/free-photo/woman-getting-scalp-prp-treatment-high-angle_23-2149404693.jpg?uid=R66916925&ga=GA1.1.8515140.1733411424&semt=ais_hybrid',
          details: [
            'Platelet-rich plasma therapy',
            'Growth factor concentrate',
            'Natural healing process',
            'Multiple sessions',
            'Long-lasting results'
          ],
          icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          ),
        },
      ],
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <section id="services" className="py-12 sm:py-16 md:py-20 bg-gray-200 relative overflow-hidden">
      <div className="w-full px-4 sm:px-6 lg:px-8 relative">
        <motion.div 
          className="text-center mb-8 sm:mb-12 md:mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
            Our Services
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4 sm:px-6">
            Comprehensive dental and cosmetology services to meet all your needs
          </p>
        </motion.div>

        <motion.div 
          className="space-y-8 sm:space-y-10 md:space-y-12"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {services.map((category, index) => (
            <motion.div 
              key={category.title} 
              variants={itemVariants}
              className="px-4 sm:px-6"
            >
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-6 sm:mb-8">
                {category.title}
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
                {category.items.map((service) => (
                  <motion.div
                    key={service.name}
                    className="group relative overflow-hidden rounded-lg bg-white shadow-md hover:shadow-xl transition-all duration-300"
                    whileHover={{ scale: 1.02 }}
                  >
                    <div className="relative h-48 sm:h-56 overflow-hidden">
                      <img
                        src={service.image}
                        alt={service.name}
                        className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-60 transition-opacity duration-300" />
                    </div>
                    <div className="p-4 sm:p-6">
                      <div className="flex items-center space-x-2 sm:space-x-3 mb-2 sm:mb-3">
                        <div className="text-primary">
                          {service.icon}
                        </div>
                        <h4 className="text-lg sm:text-xl font-medium text-gray-900">
                          {service.name}
                        </h4>
                      </div>
                      <p className="text-sm sm:text-base text-gray-600 mb-4">
                        {service.description}
                      </p>
                      <div className={`absolute bottom-0 left-0 right-0 p-4 sm:p-6 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300 ${
                        category.title === 'Cosmetology Services' 
                          ? 'bg-pink-100' 
                          : 'bg-cyan-100'
                      }`}>
                        <h5 className={`text-sm sm:text-base font-semibold mb-2 sm:mb-3 ${
                          category.title === 'Cosmetology Services' 
                            ? 'text-pink-900' 
                            : 'text-cyan-900'
                        }`}>Service Details:</h5>
                        <ul className="space-y-1 sm:space-y-2">
                          {service.details.map((detail, idx) => (
                            <li key={idx} className={`flex items-center text-sm sm:text-base ${
                              category.title === 'Cosmetology Services' 
                                ? 'text-pink-900' 
                                : 'text-cyan-900'
                            }`}>
                              <svg className={`w-3 h-3 sm:w-4 sm:h-4 mr-2 ${
                                category.title === 'Cosmetology Services' 
                                  ? 'text-pink-600' 
                                  : 'text-cyan-600'
                              }`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                              </svg>
                              {detail}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Services;